if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false;

      // Progress Bar Berechnung
      const progressPercentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
      
      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      // CSS für Progress Bar hinzufügen
      this._injectStyles();

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            <div class="shipping-notice-content">
              <div class="shipping-message">${shippingMessage}</div>
              <div class="shipping-progress">
                <div class="progress-bar">
                  <div class="progress-fill ${shippingSuccess ? 'progress-complete' : ''}" 
                       style="width: ${progressPercentage}%"></div>
                </div>
                <div class="progress-info">
                  <span class="current-amount">${this._formatMoney(cartTotal, KROWN.settings.shop_money_format)}</span>
                  <span class="target-amount">${this._formatMoney(freeShippingThreshold, KROWN.settings.shop_money_format)}</span>
                </div>
              </div>
            </div>
          </div>`;
      } else {
        this.innerHTML = `
          <div class="shipping-notice-content">
            <div class="shipping-message">${shippingMessage}</div>
            <div class="shipping-progress">
              <div class="progress-bar">
                <div class="progress-fill ${shippingSuccess ? 'progress-complete' : ''}" 
                     style="width: ${progressPercentage}%"></div>
              </div>
              <div class="progress-info">
                <span class="current-amount">${this._formatMoney(cartTotal, KROWN.settings.shop_money_format)}</span>
                <span class="target-amount">${this._formatMoney(freeShippingThreshold, KROWN.settings.shop_money_format)}</span>
              </div>
            </div>
          </div>`;
      }

    }

    _injectStyles() {
      // Prüfen ob Styles bereits existieren
      if (!document.querySelector('#shipping-notice-styles')) {
        const style = document.createElement('style');
        style.id = 'shipping-notice-styles';
        style.textContent = `
          .shipping-notice-content {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .shipping-progress {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .progress-bar {
            width: 100%;
            height: 8px;
            background-color: #e5e5e5;
            border-radius: 4px;
            overflow: hidden;
            position: relative;
          }

          .progress-fill {
            height: 100%;
            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
            border-radius: 4px;
            transition: width 0.8s ease-in-out;
            position: relative;
          }

          .progress-complete {
            background: linear-gradient(90deg, #10b981 0%, #059669 100%) !important;
          }

          .progress-fill::after {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
            animation: shimmer 2s infinite;
          }

          @keyframes shimmer {
            0% { left: -100%; }
            100% { left: 100%; }
          }

          .progress-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #666;
          }

          .current-amount {
            font-weight: bold;
            color: #333;
          }

          .target-amount {
            color: #10b981;
            font-weight: 500;
          }

          @media (max-width: 768px) {
            .shipping-notice-content {
              gap: 10px;
            }
            
            .shipping-progress {
              gap: 6px;
            }
            
            .progress-info {
              font-size: 11px;
            }
          }
        `;
        document.head.appendChild(style);
      }
    }
    
    _formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);

    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}